import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/svg/headerPhone.svg'


const _withScopeId = n => (_pushScopeId("data-v-465295da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header_box" }
const _hoisted_2 = { class: "header_content" }
const _hoisted_3 = { class: "content_left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "content_right" }
const _hoisted_7 = {
  key: 0,
  class: "imgbox"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "400-920-1599", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "http://qing.tv",
  target: "_blank",
  style: {"color":"#fff"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "button" }, "返回首页")
], -1))

import { withDefaults } from 'vue';
import { useStore } from 'vuex';

interface IProps {
  modelValue?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SingHeader',
  props: {
    modelValue: { default: '' }
  },
  setup(__props: any) {

const props = __props as { modelValue: string };

const store = useStore();
// window.daovoice('init', {
//   app_id: '04cefad5',
//   email: 'daovoice@example.com', // 替换成当前用户的邮件
//   user_id: 'NO_89757', // 选填: 替换成当前用户的唯一标识
//   signed_up: 1449821660, // 选填: // 替换当前用户的注册时间，格式为 Unix 时间戳
//   name: '道客船长', // 选填: 替换当前用户的真名或者昵称
// });
// window.daovoice('update');
const daovoice = () => {
  // window.daovoice('show');
};
//获取定制配置
const defaultTopLogo = store.state.home.black_top_logo_url;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", null, [
          (props.modelValue)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: props.modelValue
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _unref(defaultTopLogo)
              }, null, 8, _hoisted_5))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (props.modelValue === '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
          : _createCommentVNode("", true),
        _hoisted_11
      ])
    ])
  ]))
}
}

})